import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import DatetimeDisplay from '../date-time-display';

class OrganizationLastSyncRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.requestShowSyncLogs(this.props.data);
  }

  render() {
    const {
      data, value, showError, requestShowSyncLogs,
    } = this.props;
    if (!data || !value) {
      return null;
    }
    const org = data.organization || data;
    let cls = null;
    let inner = (<DatetimeDisplay value={value} format="shortWithTime" />);

    if (org.last_synced_success === false && showError) {
      cls = 'text-danger';
      const tip = (
        <Tooltip id={`sync-error-tip-${org._id}`}>
          <div>Sync Error</div>
        </Tooltip>
      );

      if (requestShowSyncLogs) {
        inner = (
          <a
            href=""
            onClick={this.handleClick}
          >
            <span className={cls}>{inner} <Fa name="exclamation-triangle" /></span>
          </a>
        );
      } else {
        inner = (
          <span className={cls}>{inner}</span>
        );
      }
      return (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          {inner}
        </OverlayTrigger>
      );
    }
    return inner;
  }
}

OrganizationLastSyncRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string,
    last_synced_success: PropTypes.bool,
  }),
  showError: PropTypes.bool,
  requestShowSyncLogs: PropTypes.func,
};
OrganizationLastSyncRenderer.defaultProps = {
  value: null,
  data: null,
  showError: false,
  requestShowSyncLogs: null,
};

export default OrganizationLastSyncRenderer;
